import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";

function App() {
  // All blur, focus, and context-menu restrictions have been removed.

  return (
    <Router>
      <div className="app-container">
        <Routes>
          {/* The main route for customers to view collections.
            Example: yoursite.com/view/a1b2c3d4 
          */}
          <Route path="/view/:shareId" element={<Home />} />
          <Route path="/product/:shareId" element={<Home />} />          {/* Fallback for the root path */}
          <Route path="/" element={<Navigate to="/view/default" replace />} />
        </Routes>
      </div>

      <style>{`
        /* Standard styling without selection or touch restrictions */
        .app-container {
          min-height: 100vh;
        }

        /* Standard image behavior */
        img {
          max-width: 100%;
          height: auto;
        }
      `}</style>
    </Router>
  );
}

export default App;